export default "__VITE_ASSET__6100c5d0__"